const netWorth = [
  {
    value: 'I do not have any assets',
    text:  'Não possuo patrimônio',
  },
  {
    value: 'My assets are worth less than R$ 10.000,00',
    text:  'Até R$ 10.000,00',
  },
  {
    value: 'My assets are worth between R$ 10.000,00 and R$ 50.000,00',
    text:  'Entre R$ 10.000,00 e R$ 50.000,00',
  },
  {
    value: 'Over R$ 50.000,00',
    text:  'Acima de R$ 50.000,00',
  },
];
export default netWorth;
